var map = {
	"./template.bet575": 1715,
	"./template.bet575.tsx": 1715,
	"./template.bet777": 1716,
	"./template.bet777.tsx": 1716,
	"./template.betbetbet": 1717,
	"./template.betbetbet.tsx": 1717,
	"./template.betprofessor": 1718,
	"./template.betprofessor.tsx": 1718,
	"./template.betroyale": 1719,
	"./template.betroyale.tsx": 1719,
	"./template.betstride": 1720,
	"./template.betstride.tsx": 1720,
	"./template.buffalobet": 1981,
	"./template.buffalobet.tsx": 1981,
	"./template.chromabet": 1721,
	"./template.chromabet.tsx": 1721,
	"./template.default": 671,
	"./template.default.tsx": 671,
	"./template.epicodds": 1722,
	"./template.epicodds.tsx": 1722,
	"./template.fiestabet": 1723,
	"./template.fiestabet.tsx": 1723,
	"./template.forsport": 1724,
	"./template.forsport.tsx": 1724,
	"./template.gigabet": 1725,
	"./template.gigabet.tsx": 1725,
	"./template.goldenbet888": 1726,
	"./template.goldenbet888.tsx": 1726,
	"./template.goldenrush": 1727,
	"./template.goldenrush.tsx": 1727,
	"./template.hyperbet": 1728,
	"./template.hyperbet.tsx": 1728,
	"./template.juicybet": 1729,
	"./template.juicybet.tsx": 1729,
	"./template.junglebet": 1730,
	"./template.junglebet.tsx": 1730,
	"./template.magnumbet": 1731,
	"./template.magnumbet.tsx": 1731,
	"./template.oldgill": 1732,
	"./template.oldgill.tsx": 1732,
	"./template.puntcity": 1733,
	"./template.puntcity.tsx": 1733,
	"./template.puntgenie": 1734,
	"./template.puntgenie.tsx": 1734,
	"./template.pyramidbet": 1735,
	"./template.pyramidbet.tsx": 1735,
	"./template.questbet": 1736,
	"./template.questbet.tsx": 1736,
	"./template.slambet": 1737,
	"./template.slambet.tsx": 1737,
	"./template.sterlingparker": 1738,
	"./template.sterlingparker.tsx": 1738,
	"./template.sugarcastle": 1739,
	"./template.sugarcastle.tsx": 1739,
	"./template.templebet": 1740,
	"./template.templebet.tsx": 1740,
	"./template.titanbet": 1743,
	"./template.titanbet.tsx": 1743,
	"./template.ts": 984,
	"./template.vikingbet": 1744,
	"./template.vikingbet.tsx": 1744,
	"./template.volcanobet": 1745,
	"./template.volcanobet.tsx": 1745,
	"./template.wellbet": 1746,
	"./template.wellbet.tsx": 1746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2475;